import { Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import MBSCodeModal from './MBSCodeModal';
import Store from './Store';
import MBSCodeTable from './MBSCodeTable';
import Toolbar from './Toolbar';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

@observer
class MBSCodes extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/mbs-code', true);
      return;
    }
    Store.fetchCategories();
    Store.fetchGroups();
    Store.fetchData(true);
    Store.fetchStateList();
  }
  render() {
    const { loading, loadingServiceGroup, data, open, dataServiceGroup } = Store;
    return (
      <div className={`Table-${loadingServiceGroup && !data && !dataServiceGroup ? 'loading' : 'container'}`}>
        {loading && loadingServiceGroup && !dataServiceGroup ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <Toolbar />
            <MBSCodeTable />
            {open && <MBSCodeModal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default MBSCodes;
